module.exports = __webpack_public_path__ + "static/media/penguin-migration.e1605dcd.png";